"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventFactory = void 0;
var uuid_1 = require("uuid");
var create_context_1 = require("./functions/create-context");
var EventFactory = /** @class */ (function () {
    function EventFactory(user) {
        this.user = user;
    }
    EventFactory.prototype.context = function (event) {
        var _a;
        return (_a = event.context) !== null && _a !== void 0 ? _a : (0, create_context_1.createContext)();
    };
    EventFactory.prototype.track = function (event, properties, options) {
        return this.normalize(__assign(__assign(__assign(__assign({}, this.baseEvent()), { event: event, type: 'track' }), options), { properties: properties }));
    };
    EventFactory.prototype.page = function (category, page, properties, options) {
        var propertiesData = __assign({}, properties);
        if (category !== null) {
            propertiesData.category = category;
        }
        if (page !== null) {
            propertiesData.name = page;
        }
        var event = __assign(__assign({ type: 'page' }, options), { properties: __assign({}, propertiesData) });
        return this.normalize(__assign(__assign({}, this.baseEvent()), event));
    };
    EventFactory.prototype.identify = function (userId, userAttributes, options) {
        return this.normalize(__assign(__assign(__assign(__assign({}, this.baseEvent()), { type: 'identify' }), options), { userId: userId, userAttributes: userAttributes }));
    };
    EventFactory.prototype.baseEvent = function () {
        var base = {};
        var user = this.user;
        if (user.id()) {
            base.userId = user.id();
        }
        if (user.anonymousId()) {
            base.anonymousId = user.anonymousId();
        }
        return base;
    };
    EventFactory.prototype.normalize = function (event) {
        var body = __assign({ timestamp: new Date() }, event);
        var context = this.context(event);
        var messageId = 's10-event-' + (0, uuid_1.v4)();
        var evt = __assign(__assign({}, body), { context: context, messageId: messageId });
        return evt;
    };
    return EventFactory;
}());
exports.EventFactory = EventFactory;
//# sourceMappingURL=event-factory.js.map